"use strict";

exports.__esModule = true;
exports.UpdateScheduleScreen = UpdateScheduleScreen;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _App = require("../../App");
var _UpdateScheduleWizard = require("../Schedule/UpdateScheduleWizard");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function UpdateScheduleScreen(_ref) {
  var id = _ref.match.params.id;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("UpdateScheduleScreen.title", "Edit Schedule"),
    "data-testid": "UpdateScheduleScreen"
  }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
    title: translate("UpdateScheduleScreen.navbar.title", "Edit Schedule")
  }), /*#__PURE__*/_react["default"].createElement(_UpdateScheduleWizard.UpdateScheduleWizard, {
    id: id
  }));
}